import { GENDER } from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse, InstitutionProp } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const PATIENT_URL = '/patients/v1/visited-patients';

export interface ParamsGetPatientsVisited {
  institution_ids?: string;
  limit?: number;
  offset?: number;
  patient_id?: string;
  patient_name?: string;
  sort_field?: '' | 'updated_at';
  sort_order?: SORT_ORDER;
  updated_at_from?: string;
  updated_at_to?: string;
  visit_id?: string;
}
export interface ResponseGetPatientsVisited extends DefaultResponse {
  data: {
    address: string;
    birth_date: string;
    created_at: string;
    email: string;
    id: string;
    institution: InstitutionProp;
    institution_id: string;
    patient_id: string;
    patient_name: string;
    phone: string;
    sex: GENDER;
    updated_at: string;
    visit_date: string;
    visit_id: string;
  }[];
}
export const getPatientsVisited = async (
  params: ParamsGetPatientsVisited = {
    limit: 100,
    offset: 0,
  }
) => {
  const response = (await api({
    url: PATIENT_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetPatientsVisited>;

  return response.data;
};

/* export interface ParamsCreatePatient {}
export interface ResponseCreatePatient extends DefaultResponse {
  data: {};
}
export const createPatient = async (data: ParamsCreatePatient) => {
  const response = (await api({
    url: `${PATIENT_URL}`,
    method: 'POST',
    data,
  })) as AxiosResponse<ResponseCreatePatient>;

  return response.data;
}; */

/* export interface ParamsUpdatePatient {}
export interface ResponseUpdatePatient extends DefaultResponse {
  data: {};
}
export const updatePatient = async (id: string, data: ParamsUpdatePatient) => {
  const response = (await api({
    url: `${PATIENT_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<ResponseUpdatePatient>;

  return response.data;
}; */

/* export interface ParamsDeletePatient {}
export interface ResponseDeletePatient extends DefaultResponse {
  data: {};
}
export const deletePatient = async (id: string) => {
  const response = (await api({
    url: `${PATIENT_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<ResponseDeletePatient>;

  return response.data;
}; */

export interface ParamsResetPasswordPatient {}
export interface ResponseResetPasswordPatient extends DefaultResponse {}
export const resetPasswordPatient = async (id: string) => {
  const response = (await api({
    url: `${PATIENT_URL}/${id}/reset-password`,
    method: 'POST',
  })) as AxiosResponse<ResponseResetPasswordPatient>;

  return response.data;
};
